/*!
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

<template>
  <div id="home">

    <div v-if="!authState || !authState.isAuthenticated">
      <div class="ui raised very padded text container segment">
        <h1 class="ui header">Welcome to your Humane Device Dashboard!</h1>
        <p>When you click the login button below, you will be redirected to the login page on Okta.</p>
        <button id="login-button" role="button" v-on:click="login()" class="fluid ui primary button" tabindex="0">
                <!-- <a class="ui image primary label"> -->
                  <img class="ui centered tiny image" src="../assets/okta.png">
                <!-- </a> -->
        </button>
      </div>
    </div>

    <div class="ui raised very padded text container segment" v-if="authState && authState.isAuthenticated">
      <h1 class="ui header">Welcome to your Humane Device Dashboard!</h1>
      <p>
        Hi {{claims && claims.name}}! This dashboard is an easy means for viewing and reassigning your assets. Navigate to <a href="/devices">My Devices</a> to see what is currently checked out to you.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'home',
  data: function () {
    return {
      claims: '',
    }
  },
  created () {this.setup()},
  methods: {
    async setup () {
      if (this.authState && this.authState.isAuthenticated) {
        this.claims = await this.$auth.getUser()
      }
    },
    login () {
      this.$auth.signInWithRedirect({ originalUri: '/devices' })
    }
  }
}
</script>
